import { render, staticRenderFns } from "./SalesManList.vue?vue&type=template&id=b4a8be36&"
import script from "./SalesManList.vue?vue&type=script&lang=js&"
export * from "./SalesManList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports